module.exports = __webpack_public_path__ + "static/img/step01.aae337e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyprocess/step01.png
// module id = PG/U
// module chunks = 1